import { Link } from 'react-router-dom';
import SEOMeta from '../../components/SEOMeta';
import { useDarkMode } from '../../hooks/useDarkMode';

export default function ObrigadoPage() {
  const isDark = useDarkMode();
  return (
    <>
      <SEOMeta
        title="Pagamento Recebido | Inspira Músicas"
        description="Pagamento confirmado. Sua música está sendo criada."
        path="/obrigado"
        noIndex
      />
    <div style={{ background: 'var(--cream)', minHeight: '100vh', fontFamily: "'DM Sans', sans-serif" }}>
      {/* Header */}
      <header style={{ background: 'var(--warm-white)', borderBottom: '1px solid var(--beige-mid)', padding: '14px 24px', textAlign: 'center' }}>
        <Link to="/">
          <img src={isDark ? '/logo-dark.png' : '/logo-light.png'} alt="Inspira Músicas" style={{ height: 52, objectFit: 'contain' }} />
        </Link>
      </header>

      {/* Main */}
      <main style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 16px', minHeight: 'calc(100vh - 73px)' }}>
        <div style={{
          background: 'var(--warm-white)',
          border: '1px solid var(--border-soft)',
          borderRadius: 24,
          padding: '48px 36px',
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 40px rgba(200,131,42,0.10)',
        }}>
          {/* Checkmark */}
          <div style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, var(--gold), var(--gold-light))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 28px',
            boxShadow: '0 6px 28px rgba(200,131,42,0.30)',
          }}>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M8 18L15 25L28 11" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 26,
            color: 'var(--earth)',
            margin: '0 0 12px',
            lineHeight: 1.3,
          }}>
            Pagamento recebido!
          </h1>

          <p style={{ color: 'var(--text-strong)', fontSize: 16, margin: '0 0 8px', lineHeight: 1.7 }}>
            Sua música está sendo composta com carinho.
          </p>
          <p style={{ color: 'var(--text-muted)', fontSize: 15, margin: '0 0 32px', lineHeight: 1.7 }}>
            Em até <strong style={{ color: 'var(--gold)' }}>30 minutos</strong> você receberá a música no e-mail que informou no pedido.
          </p>

          {/* Divider */}
          <div style={{ height: 1, background: 'linear-gradient(90deg, transparent, var(--border-fade), transparent)', margin: '0 0 28px' }} />

          <p style={{ color: 'var(--text-soft)', fontSize: 13, margin: '0 0 24px', lineHeight: 1.6 }}>
            Dúvidas? Fale com a gente pelo e-mail{' '}
            <a href="mailto:contato@inspiramusicas.com.br" style={{ color: 'var(--gold)', fontWeight: 600 }}>
              contato@inspiramusicas.com.br
            </a>
          </p>

          <Link
            to="/"
            style={{
              display: 'inline-block',
              padding: '12px 32px',
              background: 'var(--gold)',
              color: '#fff',
              borderRadius: 999,
              textDecoration: 'none',
              fontSize: 15,
              fontWeight: 600,
              boxShadow: '0 4px 20px rgba(200,131,42,0.28)',
            }}
          >
            Voltar ao início
          </Link>
        </div>
      </main>
    </div>
    </>
  );
}
